import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthService } from 'app/login/services/auth.service';
import { Role } from 'app/shared/models/role';
import { Subscription } from 'rxjs/Subscription';

@Directive({ selector: '[hasPermission]' })
export class HasPermissionDirective implements OnDestroy {
  
  private _userSubscription:Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService:AuthService
    ) { }

  @Input() set hasPermission(role: string) {
    if (this._userSubscription) {
      this._userSubscription.unsubscribe();
    }

    this._userSubscription = this.authService.getLoginState().subscribe(loginState => {
      let user = loginState.user;
      this.viewContainer.clear();
      if (user && user.role <= Role[role]) {
          this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }

  ngOnDestroy(): void {
    if (this._userSubscription) {
      this._userSubscription.unsubscribe();
    }
  }


}


// WEBPACK FOOTER //
// ./src/app/login/has-permission/has-permission.ts